import { render } from "./Perseguido_Agitado.vue?vue&type=template&id=2a58b8b0"
import script from "./Perseguido_Agitado.vue?vue&type=script&lang=js"
export * from "./Perseguido_Agitado.vue?vue&type=script&lang=js"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__